// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__1V5gG","img3":"Home_img3__ot-af","img4":"Home_img4__1wOJB"};